import React, { useCallback, useEffect, useState } from "react";
import DistributorTable from "../../components/table/DistributorTable";
import { useSelector } from "react-redux";
import DistributorApi from "../../utils/api/DistributorApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./History.module.css";

function DistributorDebit() {
  const [allTransactions, setAllTransactions] = useState(null);
  const [filteredTransactions, setFilteredTransactions] =
    useState(allTransactions);
  const [searchInput, setSearchInput] = useState("");
  const [pageNumber, setPageNumber] = useState(1);

  const token = useSelector((state) => state.userData.loginData.token);

  const fetchCustomers = useCallback(async () => {
    try {
      const response = await DistributorApi.getDebitHistory({
        token,
        page_no: pageNumber,
      });
      setAllTransactions(response.data.data);
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token, pageNumber]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  useEffect(() => {
    const transactions = allTransactions?.data || allTransactions;
    if (searchInput === "") {
      setFilteredTransactions(transactions);
    } else {
      const filtered = transactions?.filter((customer) =>
        customer.user?.fullname
          ?.toLowerCase()
          ?.includes(searchInput?.toLowerCase())
      );
      setFilteredTransactions(filtered);
    }
  }, [searchInput, allTransactions]);
  return (
    <div>
      <ToastContainer />

      <div className={styles.filter_wrapper}>
        <input
          type="text"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          placeholder="Search transactions"
          className={styles.filter_input}
        />
        <button className={styles.export_button}>Export</button>
      </div>
      <div style={{ display: "inline" }}>
        <button
          onClick={() => setPageNumber(pageNumber - 1)}
          disabled={pageNumber === allTransactions?.from}
          style={{
            backgroundColor:
              pageNumber === allTransactions?.from ? "grey" : "#1814F3",
            color: "white",
            padding: "5px 10px",
            margin: "5px",
            border: "none",
            float: "left",
            borderRadius: "5px",
          }}
        >
          Prev
        </button>
        <button
          onClick={() => setPageNumber(pageNumber + 1)}
          disabled={pageNumber === allTransactions?.last_page}
          style={{
            backgroundColor:
              pageNumber === allTransactions?.last_page ? "grey" : "#1814F3",
            color: "white",
            padding: "5px 10px",
            margin: "5px",
            border: "none",
            float: "left",
            borderRadius: "5px",
          }}
        >
          Next
        </button>
      </div>
      <DistributorTable tableData={filteredTransactions} debit="debit" />
    </div>
  );
}

export default DistributorDebit;
